import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig  } from 'axios';




export interface glass {
    "id"?: number,
    "name"?:string,
    "code"?: string,
    "is_priced"?: number,
    "created_at"?: null,
    "updated_at"?: null,
    "glassworks"?: iGlassWork[]
}


export type sortDirectionType= 'ASC' | "DESC"
interface pagination {
    page: number,
    page_size: number,
    keyword?: string,
    sort_field?:number,
    sort_direction?:sortDirectionType,
    date_from?:string ,
    date_to?:string
}
export interface price   {
    "id": number,
    "glass_id":number,
    "glass_work_id":number,
    "price": number,
 
    "glassworks": iGlassWork,
    "glasses": glass
}
export interface priceResponse {
    pid: number,
    "price": number,
    "gid": number,
    "gname": string,
    "gcode": string,
    "is_priced": number,
    "gwid": number,
    "gwname": string,
    "gwcode": string,
    "min_area": number,
    "unit": string
}

interface role {
    id?: number;
    name: string;
    permissions: number[];
}

interface user {
    id?: number;
    employee_id: number;
    email: string;
    password: string;
    role_id: number;
}

interface employee {
    id?: number;
    name: string;
    serial_no: string;
    mobile: string;
    job: string;
    salary: number;
    working_status: 'Working' | 'Pending' |'Suspended';
}

interface salary {
    employee_id?: number;
    salary?: number;
    additional_time?: number;
    additional_value?: number;
    absence_time?: number;
    discount_value?: number;
    net_salary?: number;
    date?: string;
}

type attribute = {
    name?: string;
    type?: string;
    hint?: string;
    items?: string[];
    min?: number;
    max?: number;
}

interface component {
    id?: number;
    name: string;
    serial_no: string;
    description: string;
    attributes_list: attribute[];
}

interface product {
    id?: number;
    name?: string;
    serial_no?: string;
    description?: string;
    price?: number;
    components?: {
        id?: number;
        amount?: number;
        attributes: {
            attribute_id: number;
            value: string;
        }[];
    }[];
}

interface supplier {
    id?: number;
    name?: string;
    account_no?: string;
    serial_no?: string;
    phone?: string;
    fax?: string;
    mobile?: string;
    email?: string;
    website?: string;
    country?: string;
    government?: string;
    city?: string;
    postal_code?: string;
    department_number?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
    
}

export interface client extends supplier {
    type?: 'Cash' | 'Post Paid';
    debt_ceiling?: number;
    bill?:bill[]
}
export interface orderdetail {
    glass_id?:number,
    glass_work_id?:number,
    price?:number,
    piece_code?:string,
    piece_count?:number,
    length?:number,
    width?:number,
    area?:number,
    total?:number,
    glass_work?:iGlassWork,
    glass?:glass,
    glasswork_code?:string,
    glass_code?:string,
    test_field?:number
}

export interface iOrderDetail {
    
        "id"?: number,
        "price"?: number,
        "order_id"?: number,
        "piece_code"?: string,
        "piece_count"?: number,
        "length"?: number,
        "width"?: number,
        "area"?: number,
        "total"?: number,
        "glass_id"?:number,
        "glass_work_id"?:number,
        "glass_work"?: iGlassWork,
        "glass"?: glass
    
}

export interface iStatusOperation {
    id:number,
    status:string,
    operation:string,
    code:number,
    function : string
}
export interface iOrderStatus {
    id:number,
    order_id:number,
    status:string,
    status_date:string,
    code:number,
    function :string
}
export interface order {
    id?: number;
    client_id?: number;
    order_no?: string;
    date?: string;
    delivery_date?: string;
    summary?: string;
    delivery_order_issued?: boolean;
    invoice_issued?: boolean;
    job_order_printed?: boolean;
    quotation_printed?: boolean;
    products?: { id?: number; amount?: number; }[]
    order_details?:orderdetail[],
    client_name?:string,
    client?:client,
    client_phone?:string,
    bill?:any,
    glass_summary?:string,
    glass_work_summary?:string,
    job_order_date?:string,
    orderdetail?:iOrderDetail[],
    isLoadingPrintOrder?:boolean,
    orderstatus?:iOrderStatus[],
    bill_id?:number
}
export interface updateOrder {
    id: number;
    client_id: number;
    order_no: string;
    date: string;
    summary: string;
    delivery_date:string;
    order_details?:orderdetail[],
    glass_summary:string;
    glass_work_summary:string
    status:string
}
export type order_details_extended = orderdetail& {single_price?:number ,total_price?:number,serial_number?:number,raw_price?:number}

export interface storeOrder {
    client_id: number;
    order_no: string;
    date: string;
    summary: string;
    delivery_date:string|null;
    order_details?:order_details_extended  [],
    glass_summary:string;
    glass_work_summary:string,
    client?:client
}

export interface iBillDetails {
    piece_code?:string,
    description?:string,
    count?:string,
    measures?:string,
    area?:number,
    price?:string,
    total?:number,
    piece_count?:number
    id?: number,
    bill_id?: number,
    created_at?: null,
    updated_at?: null,
    glass_id?: number,
    orderdetail_id?: number
    glass_work_id?:number,
    unit?:unit_type

}
export interface bill_request {
    order_id:number,
    billdetails :iBillDetails[],
    client_id:number , 
    bill_no:string , 
    date:string ,
    type:'Cash'|'Post Paid',
    total:number ,
    discount_percentage:number , 
    discount_amount:number , 
    discount_value:number , 
    total_net:number , 
    tax_amount:number , 
    net_after_tax:number ,
    net_after_tax_str:string ,
    paid:number , 
    remains:number ,
    seller_name:string ,
    note?:string ,
    piece_count:number,
    items_count:number,
    delivery_order:string,


}
export interface bill {
    id?: number;
    order_id?: number;
    client_id?: number;
    bill_no?: string;
    date?: string;
    type?: 'Cash' | 'Post Paid';
    total?: number;
    discount_percentage?: number;
    discount_amount?: number;
    discount_value?: number;
    total_net?: number;
    tax_amount?: number;
    net_after_tax?: number;
    net_after_tax_str?: string;
    paid?: number;
    remains?: number;
    seller_name?: string;
    note?:string,
    piece_count?:number,
    items_count?:number,
    delivery_order?:string,
    billdetail?:iBillDetails[],
    "delivery_order_date"?: null | string,
    client?:client,
    order_no?:string,
    code?:number,
    order_statusescode?:number,
    order_statusesname?:string
}

interface receiptOrder {
    id?: number;
    supplier_id?: number;
    receipt_order_no?: string;
    date?: string;
    type?: 'Cash' | 'Post Paid';
    paid?: number;
    remains?: number;
    total?: number;
    materials?: {
        component_id?: number;
        amount?: number;
        price?: number;
        attributes: {
            attribute_id: number;
            value: string;
        }[];
    }[];
}

interface receiptVoucher {
    id?: number;
    client_id?: number;
    order_id?: number;
    voucher_no?: string;
    date?: string;
    value?: number;
    paragraph?: string;
}

interface paymentVoucher {
    id?: number;
    client_id?: number;
    voucher_no?: string;
    date?: string;
    value?: number;
    paragraph?: string;
}
export type unit_type = 'Area'|'Length'|'Piece'
interface iGlassWork {
                         "id"?:number,
                        "name"?: string,
                        "code"?: string,
                        "min_area"?: number,
                        "unit"?: unit_type,
                        "created_at"?: null,
                        "updated_at"?: null,
                        "glass_id"?: number,
                        "glass_work_id"?:number,
                        "price"?: number,
                      
}




export interface selectByGlasses {
    
        "pid"?: number,
        "price"?: number,
        "gid"?: number,
        "gname"?: string,
        "gcode"?:string,
        "is_priced"?: number,
        "gwid"?: number,
        "gwname"?: string,
        "gwcode"?: string,
        "min_area"?: number,
        "unit"?: string
    
}

export interface iPurchaseOrderDetail  {
    "id"?: number,
    "purchase_order_id"?: string,
    "glass_id"?: string,
    "length"?: string,
    "width"?: string,
    "area"?: string,
    "sheet_total"?: string,
    "sheet_count"?: string,
    "box_count"?: string,
    description?:string,
    "glass"?: {
        "id": number,
        "name": string,
        "code"?: string,
        "is_priced"?: string,
       
        "glassworks"?: iGlassWork[]
    }
}
interface iSupplier {

    "id": number,
    "name": string,
    "account_no": string,
    "serial_no": string,
    "phone"?: string,
    "fax"?: string,
    "mobile"?: string,
    "email"?: string,
    "website"?: string,
    "country": string,
    "government": string,
    "city": string,
    "department_number"?: string,
    "postal_code"?: string,
    "address_1"?: string,
    "address_2"?: string,
    "address_3"?: string

}
export type orderStatus='Approved' | 'Pending' |'Rejected' 
export type Etype ='Cash'| 'Debt'
export interface iPurchaseOrderResponse {
  
        
            "id": number,
            invoice_issued?:number,
            "order_no"?: string,
            "date"?: string,
            "summary"?: string,
            "order_status"?: orderStatus,
            "supplier_name"?:string,
            "supplier_id"?:string,
            "bill_id"?: string,
            "purchaseorderdetail"?: iPurchaseOrderDetail[],
            "supplier"?: iSupplier,
            type?:Etype,
         

        

}
export interface iPurchaseOrder {
    supplier_id:number,
    order_no:string,
    date:string,
    summary:string,
    "invoice_issued"?:number,
    order_details:iPurchaseOrderDetail[]
}
export interface iPurchaseBillDetail {
    
        "id"?: number,
        "purchase_bill_id"?: string,
        "glass_id": string,
        "purchase_order_details_id"?: string,
        "description": string,
        "box_count": string,
        "sheet_count": string,
        "sheet_total": string,
        "length": string,
        "width": string,
        "area": string,
        "Price": string,
        "Total": string,
        "Tax": string,
        "Total_after_tax": string, 
        "purchase_order_id"?:number
       
    
}
export interface iPurchaseBillResponse {
 
        "id"?: number,
        "bill_no"?: string,
        "date"?: string,
        "type"?:Etype ,
        "note"?: string,
        "total"?: string,
        "tax_amount"?: string,
        "net_after_tax"?: string,
        "net_after_tax_str"?: string,
        "paid"?: string,
        "remains"?: string,
        "purchase_order_id"?:string,
        "supplier_id"?: string,
        "name"?: string,
        "order_no"?: string,
        "purchasebilldetail"?: iPurchaseBillDetail[],
        "supplier"?: iSupplier
    
}
export interface iPurchaseBill {
    order_id:number,
    supplier_id?:number,
    bill_no?:string,
    date?:string,
    type?:Etype,
    total?:string,
    tax_amount?:string,
    net_after_tax?:string,
    net_after_tax_str?:string,
    paid?:string,
    remains?:string,
    note?:string,
    billdetails?:iPurchaseBillDetail[]

}
export interface company {
    "id": number,
    "name": string,
    "commercial_name": string,
    "country": string,
    "city": string,
    "post_code": string,
    "address": string,
    "email": string,
    "phone": string,
    "fax": string,
    "website": string,
    "description": string,
    "logo":string,
    "created_at": null,
    "updated_at": null,
    "tax_number": string,
    "tax_percent": string,
    "name_ar": string,
    "commercial_name_ar": string,
    "country_ar": string,
    "city_ar": string,
    "commercial_registrar_number":string,
    "address_ar": string,
    
}
export type deliveryorderpage =   {
                        "piece_code": string,
                        "piece_count": number,
                        "area": number,
                        "price": number,
                        "total": number,
                        "description":string,
                        "measures": string,
                        "glass": string,
                        unit:unit_type
                        
                    }

export interface Iprintdeliverynote {
     "bill_number": number,
        "bill_date": string,
        "client":string,
        "total_piece_count": number,
        "total": number,
        "paid": number,
        "remain": number,
        order_date:string,
        order_num:number,
        delivery_order_date:string,

        "pages": [
            {
                "page_number": number,
                "page": deliveryorderpage[] 
            }
        ]
    }

export interface expensesType_response {
                  "id"?:number
                 ,"code"?:string
                 ,"expense"?:string
                 ,"created_at"?:string
                 ,"updated_at"?:string}  

export interface expensesType {
     name:string 
     code:string
}

export type expense_mode = 'Bank Transfer' | 'Cash'

export interface expenses_response {
      
                "id"?: number,
                "expense_type_id"?: number,
                "expense_date"?:string,
                "expense_value"?: string,
                "vat"?: string,
                "expense_mode"?: expense_mode
                "invoice_num"?: string,
                "invoice_date"?: string,
                "invoice_copy"?:string,
                "notes"?: string,
                "created_at"?: null,
                "updated_at"?: null,
                "expense_type_code"?: string,
                "expense_type_name"?:string,
                tax_num?:string
            
}

export interface expenses {
                "expense_type_id": number,
                "expense_date":string,
                "expense_value": number,
                "vat": number,
                "expense_mode": expense_mode
                "invoice_num": string,
                "invoice_date": string,
                "invoice_copy"?:File|null|string,
                "notes": string,
                tax_num?:string

}
export type edit_expenses = {id:number} & expenses


 export interface iExpensesFetchData {
    page: number
    , page_size?: number
    , keyword?: string
    , sort_direction?: sortDirectionType
    , sort_field?: number,
    date_from?: string,
    date_to?: string
  }


  export interface sells_report_response {
    area:number
    bill_date:string
    bill_no:number
    bill_total:number
    bill_total_net:number
    client_name:string
    description:string
    glass:string
    glass_code:string,
    item_total:number,
    measures:string
    net_after_tax:number
    order_no:number,
    paid:number,
    piece_code:string
    piece_count:number,
    price:number,
    remains:number,
    tax_amount:number
  }
 export interface ibilldetail_show_grouped {
     
                "bill_id"?: number,
                "description"?: string,
                "piece_count"?: string,
                "area"?: number,
                "price"?: number,
                "total"?: number
            
 }
  export interface show_grouped {
        "id"?: number,
        "bill_no"?: number,
        "date"?: string,
        "note"?: string,
        "type"?: string,
        "total"?: number,
        "discount_percentage"?: number,
        "discount_amount"?: number,
        "discount_value"?: number,
        "total_net"?: number,
        "tax_amount"?: number,
        "net_after_tax"?: number,
        "net_after_tax_str"?: string,
        "paid"?: number,
        "remains"?: number,
        "seller_name"?: string,
        "order_id"?: number,
        "client_id"?: number,
        "piece_count"?: number,
        "items_count"?: number,
        "delivery_order"?: number,
        "delivery_order_date"?: string,
        "qr_code"?: null,
        "is_tax_bill_issued"?: number,
        "client_name"?:string ,
        "order_no"?: number,
        "delivery_date"?: string,
        "code"?: number,
        "billdetail": ibilldetail_show_grouped[] ,
        client:client
    }

 let is_production=true
 let online= true
 export const img_url =online? `${is_production?
                 'https://workshop.ergsaudi.com':'https://workshop.jaiaprojects.com'}/api/storage/app/public/`
                 : 'http://144.86.56.165:8081/api/storage/app/public/'  

class API {

    url: string;
  

    constructor(private accessToken: string, private removeCookie: (name: string) => void) {
        // this.url = "http://127.0.0.1:8000"
    
        this.url =online? `${is_production?'https://workshop.ergsaudi.com':'https://workshop.jaiaprojects.com'}/api/public`
                 : 'http://144.86.56.165:8081/api/public'
            

        
        
   
        // Add Auth header
        axios.interceptors.request.use((config:InternalAxiosRequestConfig<any>) => {
            if (config.headers){
           config.headers["Accept"] = "application/json";
            // if (!config.headers?.["Content-Type"]) {
            //     config.headers["Content-Type"] = "application/json";
            // }
            config.headers["X-Requested-With"] = "XMLHttpRequest";

            if (this.accessToken) {
                config.headers["Authorization"] = `${this.accessToken}`;
            }
          
}
  return config;
        })

        // Handle 401
         axios.interceptors.response.use((response:AxiosResponse) => {
            
             if (!response)
                 return Promise.reject(response)
             else {
                if (response.data.message === "Unauthenticated!" || response.data?.error?.message === "Unauthenticated!") {
                    this.removeCookie('userinfo')
                    sessionStorage.removeItem('permissions')
                    document.location.href= '/login'
                 
                }
                return response
             }    
         },  (error:AxiosError) => {

             if (!error)
                 return Promise.reject(error);
             if (401 === error.response?.status) {
                
                 this.removeCookie("userinfo")
                 this.removeCookie("token")
                  document.location.href= '/login'
                
             } 
             if (403 === error.response?.status) {
               //if (!newPermission) setNewPermission(true)
             }
             else {
             
                 return Promise.reject(error);
             }
         });
    }
 

    /**
     * Authentication APIs
     * @param {}
     */
    auth(): {
        login(query: { email: string, password: string }, name?: string): any;
        logout(query: null, name?: string): any;
    } {
        var endpoints: any = {}

        endpoints.login = (query: any, name = 'login') => axios.post(`${this.url}/${name}`, query)

        endpoints.logout = (query: any, name = 'logout') => axios.post(`${this.url}/${name}`, query)

        return endpoints
    }


    /**
     * Roles APIs
     * @param {}
     */
    roles(): {
        index(query: pagination): any;
        permissions(query: pagination): any;
        show(query: { id: number }): any;
        showPermissions(query: { id: number }): any;
        store(query: role): any;
        update(query: role): any;
        delete(query: { ids: number[] }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'roles') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.permissions = (query: any, name = 'roles/permissions') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'roles/show') => axios.get(`${this.url}/${name}`, { params: query })
        endpoints.showPermissions = (query: any, name = 'roles/showPermissions') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'roles/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'roles/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "roles/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Users APIs
     * @param {}
     */
    users(): {
        index(query: pagination): any;
        show(query: { id: number }): any;
        store(query: user): any;
        update(query: user): any;
        delete(query: { ids: number[] }): any;
        fetch_my_info(query: null): any;
        update_my_info(query: { name?: string; email?: string; mobile?: string; passowrd?: string; }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'users') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'users/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'users/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "users/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.fetch_my_info = (query: null, name = 'users/fetch-user-info') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.update_my_info = (query: any, name = 'users/update-user-info') => axios.post(`${this.url}/${name}`, query)

        return endpoints
    }


    /**
     * Employees APIs
     * @param {}
     */
    employees(): {
        index(query: pagination & { has_user?: string }): any;
        store(query: employee): any;
        update(query: employee): any;
        delete(query: { ids: number[] }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'employees') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'employees/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'employees/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "employees/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        return endpoints
    }

    /**
     * Salaries APIs
     * @param {}
     */
    salaries(): {
        index(query: pagination): any;
        store(query: { salaries: salary[] }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'salaries') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'salaries/store') => axios.post(`${this.url}/${name}`, query)

        return endpoints
    }


    /**
     * Components APIs
     * @param { type: "material" | "service" }
     */
    components(type: "material" | "service"): {
        index(query: pagination): any;
        store(query: component): any;
        update(query: component): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'components') => axios.get(`${this.url}/${name}`, { params: { ...query, type } })

        endpoints.store = (query: any, name = 'components/store') => axios.post(`${this.url}/${name}`, { ...query, type })

        endpoints.update = (query: any, name = 'components/update') => axios.post(`${this.url}/${name}`, { ...query, type })

        endpoints.delete = (query: any, name = "components/delete") => axios.delete(`${this.url}/${name}`, { params: { ...query, type } })

        endpoints.show = (query: any, name = 'components/show') => axios.get(`${this.url}/${name}`, { params: { ...query, type } })

        return endpoints
    }


    /**
     * Glasses APIs
     * 
     */
    glasses(): {
        index(query: pagination): any;
        store(query: any): any;
        update(query: any): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
        serviceNotPriced(query: { id?: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'glasses') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.store = (query: any, name = 'glasses/store') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.update = (query: any, name = 'glasses/update') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.delete = (query: any, name = "glasses/delete") => axios.delete(`${this.url}/${name}`, { params: { ...query } })

        endpoints.show = (query: any, name = 'glasses/show') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.serviceNotPriced = (query: any, name = 'glasses/servicenotpriced') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        return endpoints
    }


    /**
     * GloassWorks APIs
     * 
     */
    glassWorks(): {
        index(query: pagination): any;
        store(query: any): any;
        update(query: any): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
        glassNotPriced(query: { id?: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'glassworks') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.store = (query: any, name = 'glassworks/store') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.update = (query: any, name = 'glassworks/update') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.delete = (query: any, name = "glassworks/delete") => axios.delete(`${this.url}/${name}`, { params: { ...query } })

        endpoints.show = (query: any, name = 'glassworks/show') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.glassNotPriced = (query: any, name = 'glassworks/glassnotpriced') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        return endpoints
    }

    /**
     * GloassWorks APIs
     * 
     */
    pricing(): {
        index(query: pagination): any;
        selectAll(query: pagination): any;
        selectByGlasses(query: { glass_id: number }& pagination): Promise<AxiosResponse<{data:selectByGlasses[]}>>;
        selectByGlassWorks(query: { glass_work_id: number }): any;
        addPrices(query: any): any;
        addGlassPrices(query: any): any;
        addGlassWorkPrices(query: any): any;
        updateGlassPrices(query: any): any;
        deletePrices(query: { ids: number[] }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'pricing') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.selectAll = (query: any, name = 'pricing/selectAll') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.selectByGlasses = (query: { glass_id: number }, name = 'pricing/selectByGlasses') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.selectByGlassWorks = (query: { glass_work_id: number }, name = 'pricing/selectByGlassWorks') => axios.get(`${this.url}/${name}`, { params: { ...query } })

        endpoints.addGlassPrices = (query: any, name = 'pricing/addGlassPrices') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.addGlassWorkPrices = (query: any, name = 'pricing/addGlassWorkPrices') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.addPrices = (query: any, name = 'pricing/addPrices') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.updateGlassPrices = (query: any, name = 'pricing/updatePrices') => axios.post(`${this.url}/${name}`, { ...query })

        endpoints.deletePrices = (query: any, name = "pricing/deletePrices") => axios.delete(`${this.url}/${name}`, { params: { ...query } })

        return endpoints
    }



    /**
     * Products APIs
     * @param {}
     */
    products(): {
        index(query: pagination): any;
        store(query: product): any;
        update(query: product): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'products') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'products/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'products/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "products/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'products/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Clients APIs
     * @param {}
     */
    clients(): {
        index(query: pagination): any;
        store(query: client): any;
        update(query: client): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'clients') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'clients/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'clients/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "clients/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'clients/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Suppliers APIs
     * @param {}
     */
    suppliers(): {
        index(query: pagination): any;
        store(query: supplier): any;
        update(query: supplier): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'suppliers') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'suppliers/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'suppliers/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "suppliers/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'suppliers/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Orders APIs
     * @param {}
     */
    orders(): {
        index(query: pagination): any;
        store(query: storeOrder): Promise<AxiosResponse<{data:order}>>;
        update(query:updateOrder): any;
        printJobOrder(query:{id:number,job_order_printed:string}): any;
        cancelJobOrder(query:{id:number,job_order_printed:string}): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): Promise<AxiosResponse<{data:order}>>;

        printOrder(query:{id:number}):any
        statusOperations (query:pagination):Promise<AxiosResponse<{data:{status_operations:iStatusOperation[]}}>> ;
        nextStatus (query:{status:string,order_id:number}):any;
        previousStatus (query:{status:string,order_id:number}):any
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'orders') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'orders/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'orders/update') => axios.post(`${this.url}/${name}`, query)
        endpoints.printJobOrder=(query: any, name = 'orders/issueJobOrderPrinted') => axios.post(`${this.url}/${name}`, query)
        endpoints.cancelJobOrder=(query: any, name = 'orders/cancelJobOrderPrinted') => axios.post(`${this.url}/${name}`, query)
       

        endpoints.delete = (query: any, name = "orders/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'orders/show') => axios.get(`${this.url}/${name}`, { params: query })
        
        endpoints.printOrder=(query:any,name='orders/printOrder')=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.statusOperations =(query:any,name='statusoperations')=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.nextStatus =(query:any,name='orders/nextStatus')=>axios.post(`${this.url}/${name}`,query)
        endpoints.previousStatus =(query:any,name='orders/previousStatus')=>axios.post(`${this.url}/${name}`,query)


        return endpoints
    }


    /**
     * Bills APIs
     * @param {}
     */
    bills(): {
        index(query: pagination): any;
        store(query: bill_request): any;
        update(query: bill_request&{id:number}): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): Promise<AxiosResponse<{data:bill,message:string}>>;
        showGrouped(query: { id: number }): Promise<AxiosResponse<{data:show_grouped}>>;
        create(query:{order_id:number}):any
        issueDeliveryOrder(query:{id:number}):any
        printDeliveryOrder(query:{id:number}):Promise<AxiosResponse<{message:string,data:Iprintdeliverynote}>>
        cancelDeliveryOrder(query:{id:number}):any
        issueTaxBill(query:{id:number,qr:string,issued:boolean}):any
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'bills') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'bills/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'bills/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "bills/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'bills/show') => axios.get(`${this.url}/${name}`, { params: query })
        endpoints.showGrouped= (query: any, name = 'bills/showGrouped') => axios.get(`${this.url}/${name}`, { params: query })
        endpoints.create=(query:any  ,name="bills/create") =>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.issueTaxBill=(query:any  ,name="bills/issueTaxBill") =>axios.post(`${this.url}/${name}`,query)
       
        endpoints.issueDeliveryOrder=(query:any  ,name="bills/issueDeliveryOrder") =>axios.post(`${this.url}/${name}`,query)
        endpoints.printDeliveryOrder=(query:any  ,name="bills/printDeliveryNote") =>axios.get(`${this.url}/${name}`,{ params: query })
        endpoints.cancelDeliveryOrder=(query:any  ,name="bills/cancelDeliveryOrder") =>axios.post(`${this.url}/${name}`,query)

        return endpoints
    }


    /**
     * Receipt orders APIs
     * @param {}
     */
    receipt_orders(): {
        index(query: pagination): any;
        store(query: receiptOrder): any;
        update(query: receiptOrder): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'receipt_orders') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'receipt_orders/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'receipt_orders/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "receipt_orders/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'receipt_orders/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Receipt Vouchers APIs
     * @param {}
     */
    receipt_vouchers(): {
        index(query: pagination): any;
        store(query: receiptVoucher): any;
        update(query: receiptVoucher): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'receipt_vouchers') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'receipt_vouchers/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'receipt_vouchers/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "receipt_vouchers/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'receipt_vouchers/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Payment Vouchers APIs
     * @param {}
     */
    payment_vouchers(): {
        index(query: pagination): any;
        store(query: paymentVoucher): any;
        update(query: paymentVoucher): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'pay_vouchers') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'pay_vouchers/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'pay_vouchers/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "pay_vouchers/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'pay_vouchers/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }
    company(): {
        index(query: pagination): any;
        store(query: company): any;
        update(query: company): any;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
    } {
        var endpoints: any = {}

        endpoints.index = (query: any, name = 'company') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.store = (query: any, name = 'company/store') => axios.post(`${this.url}/${name}`, query)

        endpoints.update = (query: any, name = 'company/update') => axios.post(`${this.url}/${name}`, query)

        endpoints.delete = (query: any, name = "company/delete") => axios.delete(`${this.url}/${name}`, { params: query })

        endpoints.show = (query: any, name = 'company/show') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }


    /**
     * Reports APIs
     * @param {}
     */
    reports(): {
        client_orders(query: { id: number; }): any;
        client_bills(query: { id: number; }): any;
        order_bill(query: { id: number; grouped: "yes" | "no" }): any;
        executive_order(query: { id: number; }): any;
        inventory(query: {}): any;
        clients_debt(query: {}): any;
        suppliers_debt(query: {}): any;
        receipt_vouchers(query: { after?: string; before?: string; }): any;
        payment_vouchers(query: { after?: string; before?: string; }): any;
        client_account(query: { id: number; }): any;
        supplier_account(query: { id: number; }): any;
        receipt_orders(query: { after?: string; before?: string; }): any;
        sales(query: { after?: string; before?: string; }): any;
        fund_flow(query: { after?: string; before?: string; }): any;
    } {
        var endpoints: any = {}

        endpoints.client_orders = (query: any, name = 'reports/client-orders') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.client_bills = (query: any, name = 'reports/client-bills') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.order_bill = (query: any, name = 'reports/order-price') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.executive_order = (query: any, name = 'reports/execute-order') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.inventory = (query: any, name = 'reports/inventory') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.clients_debt = (query: any, name = 'reports/clients-debt') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.suppliers_debt = (query: any, name = 'reports/suppliers-debt') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.receipt_vouchers = (query: any, name = 'reports/receipt-vouchers') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.payment_vouchers = (query: any, name = 'reports/pay-vouchers') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.client_account = (query: any, name = 'reports/client-account-statement') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.supplier_account = (query: any, name = 'reports/supplier-account-statement') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.receipt_orders = (query: any, name = 'reports/receipt-orders') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.sales = (query: any, name = 'reports/sales') => axios.get(`${this.url}/${name}`, { params: query })

        endpoints.fund_flow = (query: any, name = 'reports/fund-flow-statement') => axios.get(`${this.url}/${name}`, { params: query })

        return endpoints
    }
    purchaseOrder (): {
        index(query:pagination):Promise <{data:{data:iPurchaseBillResponse[] & any}}>,
        store(query:iPurchaseOrder):Promise<{data:{data:iPurchaseOrderResponse & any}}> ,
        update(query: iPurchaseOrder & {id:number}):Promise< {data:{data:iPurchaseOrderResponse & any}}>;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): Promise<{data:{data:iPurchaseOrderResponse & any}}>;
        changeOrderStatus(query:{id:number,order_status:orderStatus}):any
    }
     {
        var endpoints: any = {}
    
        endpoints.index = (query: pagination, name = 'purchaseorders') => axios.get(`${this.url}/${name}`, { params: query })
    
        endpoints.store = (query: any, name = 'purchaseorders/store') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.update = (query: any, name = 'purchaseorders/update') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.delete = (query: any, name = "purchaseorders/delete") => axios.delete(`${this.url}/${name}`, { params: query })
    
        endpoints.show = (query: any, name = 'purchaseorders/show') => axios.get(`${this.url}/${name}`, { params: query })
        endpoints.changeOrderStatus =(query:any, name="purchaseorders/changeOrderStatus")=>axios.post(`${this.url}/${name}`,query)
    
        return endpoints
    }
    
    purchaseBill (): {
        index(query:pagination):Promise<{data:{data:iPurchaseBillResponse []}}>,
        store(query:any):Promise<{data:{data:iPurchaseBillResponse}}>,
        update(query: any): Promise<{data:{data:iPurchaseBillResponse}}>;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): any;
      
    }
     {
        var endpoints: any = {}
    
        endpoints.index = (query: pagination, name = 'purchasebills') => axios.get(`${this.url}/${name}`, { params: query })
    
        endpoints.store = (query: any, name = 'purchasebills/store') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.update = (query: any, name = 'purchasebills/update') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.delete = (query: any, name = "purchasebills/delete") => axios.delete(`${this.url}/${name}`, { params: query })
    
        endpoints.show = (query: any, name = 'purchasebills/show') => axios.get(`${this.url}/${name}`, { params: query })
       
    
        return endpoints
    }
    dashboard():{
        ordersPerClients(query:{after:string,before:string}):Promise<{data:{data:any[]}}>,
        ordersList(query:{before:string,after:string,without_job_order:1|2,without_bill:1|2,without_delivery_order:1|2}):Promise<{data:{data:any[]}}>,
        ordersPerDate(query:{after:string,before:string}):Promise<{data:{data:any[]}}>,
        topProducts(query:{counter:number}):Promise<{data:{data:any[]}}>,
        topClients(query:{counter:number}):Promise<{data:{data:any[]}}>,
        income():Promise<{data:{data:number}}>,
        outcome():Promise<{data:{data:number}}>,
        sells():Promise<{data:{data:number}}>,
        purchases():Promise<{data:{data:number}}>,

        
    }{
        var endpoints:any ={}
        endpoints.ordersPerClients=(query:any,name="dashboard/orders-per-client")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.ordersList=(query:any,name="dashboard/ordersList")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.ordersPerDate=(query:any,name="dashboard/orders-per-date")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.topProducts=(query:any,name="dashboard/top-products")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.topClients=(query:any,name="dashboard/top-clients")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.outcome=(name="dashboard/outcome")=>axios.get(`${this.url}/${name}`)
        endpoints.income=(name="dashboard/income")=>axios.get(`${this.url}/${name}`)
        endpoints.sells =(name="dashboard/sells")=>axios.get(`${this.url}/${name}`)
        endpoints.purchases =(name="dashboard/purchases")=>axios.get(`${this.url}/${name}`)
        return endpoints
    }
    reportControl():{
        purcahseReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        debtReoport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        owerReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        payVoucherReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        recieptVoucherReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        clietntReport(query:{date_from:string,date_to:string,client_id:number}):Promise<{data:{data:any[]}}>,
        supplierReport(query:{date_from:string,date_to:string,supplier_id:number}):Promise<{data:{data:any[]}}>,
        inventoryReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        suppliersDebtReport():Promise<{data:{data:any[]}}>,
        recieptOrdersReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>,
        clientsDebtReport():Promise<{data:{data:any[]}}>,
        salesReport(query:{date_from:string,date_to:string}):Promise<{data:sells_report_response[]}>,
        productionReport(query:{date_from:string,date_to:string}):Promise<{data:{data:any[]}}>

        
    }{
        var endpoints:any ={}
        endpoints.purcahseReport=(query:any,name="reports/purchasereport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.debtReoport=(query:any,name="reports/debtreport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.owerReport=(query:any,name="reports/owereport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.payVoucherReport=(query:any,name="reports/payvoucherreport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.recieptVoucherReport=(query:any,name="reports/receiptvoucherreport?")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.clietntReport=(query:any,name="reports/clientreport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.supplierReport=(query:any,name="reports/supplierreport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.inventoryReport =(query:{date_from:string,date_to:string},name="reports/inventoryreport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.suppliersDebtReport=(name="reports/suppliers-debt")=>axios.get(`${this.url}/${name}`)
        endpoints.recieptOrdersReport=(query:{date_from:string,date_to:string},name="reports/receipt-orders")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.clietntsDebtReport=(name="reports/clients-debt")=>axios.get(`${this.url}/${name}`)
        endpoints.salesReport=(query:{date_from:string,date_to:string},name="reports/sellsreport")=>axios.get(`${this.url}/${name}`,{params:query})
        endpoints.productionReport=(query:{date_from:string,date_to:string},name="reports/productionreport")=>axios.get(`${this.url}/${name}`,{params:query})

        return endpoints
    }

     expensesType (): {
        index(query:pagination):Promise<{data:AxiosResponse<{"expensetypes":expensesType_response[]}>}>,
        store(query:expensesType):Promise<{data:AxiosResponse<expensesType_response>}>,
        update(query: expensesType & {id:number}):Promise<{data:AxiosResponse<expensesType_response>}>;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): Promise<{data:AxiosResponse<expensesType_response>}>;
      
    }
     {
        var endpoints: any = {}
    
        endpoints.index = (query: pagination, name = 'expense_types') => axios.get(`${this.url}/${name}`, { params: query })
    
        endpoints.store = (query: any, name = 'expense_types/store') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.update = (query: any, name = 'expense_types/update') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.delete = (query: any, name = "expense_types/delete") => axios.delete(`${this.url}/${name}`, { params: query })
    
        endpoints.show = (query: any, name = 'expense_types/show') => axios.get(`${this.url}/${name}`, { params: query })
       
    
        return endpoints
    }

      expenses (): {
        index(query:pagination):Promise<{data:AxiosResponse<{"vouchers":expenses_response[],last_page:number}>}>,
        store(query:FormData):Promise<{data:AxiosResponse<expenses_response[]>}>,
        update(query: FormData):Promise<{data:AxiosResponse<expenses_response>}>;
        update_(query: FormData):Promise<{data:AxiosResponse<expenses_response>}>;
        delete(query: { ids: number[] }): any;
        show(query: { id: number }): Promise<{data:AxiosResponse<expenses_response>}>;
        download(query:any):any
      
    }
     {
        var endpoints: any = {}
    
        endpoints.index = (query: pagination, name = 'expense_list') => axios.get(`${this.url}/${name}`, { params: query })
    
        endpoints.store = (query: any, name = 'expense_list/store') => axios.post(`${this.url}/${name}`, query,)
    
        endpoints.update = (query: any, name = 'expense_list/updatewithoutfile') => axios.post(`${this.url}/${name}`, query)
    
        endpoints._update = (query: any, name = 'expense_list/update') => axios.post(`${this.url}/${name}`, query)
    
        endpoints.delete = (query: any, name = "expense_list/delete") => axios.delete(`${this.url}/${name}`, { params: query })
    
        endpoints.show = (query: any, name = 'expense_list/show') => axios.get(`${this.url}/${name}`, { params: query })
        endpoints.download = (query: any, name = 'expense_list/download') => axios.post(`${this.url}/${name}`, query ,{responseType:'arraybuffer'})
       
    
        return endpoints
    }

    other (): {
        viewSort (query: pagination): any
    } {
        var endpoints:any ={}
        endpoints.viewSort =(query:any,name="viewsort")=>axios.get(`${this.url}/${name}`,{params:query})
        return endpoints 
    }
}
    
    


export default API